import React from 'react';

import PropTypes from 'prop-types';

import _ from '../locale';

const locale = {
    default_text: 'empty_label_default_text',
};

const propTypes = {
    children: PropTypes.node,
};

const EmptyLabel = ({ children }) => (
    <span style={{ color: 'lightgray' }}>{children || _(locale.default_text)}</span>
);

EmptyLabel.propTypes = propTypes;

export default EmptyLabel;
